
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class EmployeeService {

    static getEmployeeListResult(CompanyCode, list, CustomFieldResult, ActionType) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            CustomField_List: CustomFieldResult,
            ActionType: ActionType
        }  
        return axios.post(BaseUrl +'Employee', data);
    }

    static SaveEmployee(CompanyCode, list,CustomFieldList, ActionType, email) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            CustomField_List: CustomFieldList,
            ActionType: ActionType
        }  
        return axios.post( BaseUrl + 'SaveEmployee?email='+email, data);
    }
}



// WEBPACK FOOTER //
// ./src/Services/EmployeeService/employeeService.js